<!-- begin::Header -->
<div class="card-header border-0 pt-5">
  <h3 class="card-title align-items-start flex-column">
    <span class="card-label fw-bolder fs-3 mb-1">Ostatnie połączenia</span>
    <span class="text-muted mt-1 fw-bold fs-7">Kampania: Wielkanoc </span>
  </h3>
  <!-- <div class="card-toolbar">
    <a href="#" class="btn btn-sm btn-light-primary">
      <app-keenicon name="plus" class="fs-3"></app-keenicon>
      New Member
    </a>
  </div> -->
</div>
<!-- end::Header -->
<!-- begin::Body -->
<div class="card-body py-3">
  <!-- begin::Table container -->
  <div class="table-responsive">
    <!-- begin::Table -->
    <table class="table table-row-dashed align-middle gs-0 gy-4">
      <!-- begin::Table head -->
      <thead>
        <tr class="fw-bolder text-muted bg-light">
          <th class="ps-4 min-w-325px rounded-start">Numer telefonu</th>
          <th class="min-w-125px">Czas dzwonienia</th>
          <th class="min-w-125px">Czas rozmowy</th>
          <th class="min-w-200px">Koszt połączenia</th>
          <th class="min-w-150px">Status</th>
          <th class="ps-4 min-w-200px text-end rounded-end"></th>
        </tr>
      </thead>
      <!-- end::Table head -->
      <!-- begin::Table body -->
      <tbody>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <!-- <div class="symbol symbol-50px me-5">
                <img
                  src="./assets/media/stock/600x400/img-26.jpg"
                  class=""
                  alt=""
                />
              </div> -->
              <div class="d-flex justify-content-start flex-column">
                <a
                  href="#"
                  class="text-gray-900 fw-bolder text-hover-primary mb-1 fs-6"
                >
                  +48 0 123 123 123
                </a>
                <span class="text-muted fw-bold text-muted d-block fs-7">
                  Wrocław
                </span>
              </div>
            </div>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              00:10
            </a>
            <span class="text-muted fw-bold text-muted d-block fs-7">Odebrane</span>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              03:14
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Rejected</span -->
            
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              0.74 zł
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Insurance</span
            > -->
          </td>
          <td>
            <span class="badge badge-light-success fs-7 fw-bold">Sukces</span>
          </td>
          <td class="text-end">
            <a
              href="#"
              class="
                btn btn-sm btn-icon btn-bg-light btn-active-color-primary
              "
            >
              <app-keenicon name="arrow-right" class="fs-2"></app-keenicon>
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <!-- <div class="symbol symbol-50px me-5">
                <img
                  src="./assets/media/stock/600x400/img-26.jpg"
                  class=""
                  alt=""
                />
              </div> -->
              <div class="d-flex justify-content-start flex-column">
                <a
                  href="#"
                  class="text-gray-900 fw-bolder text-hover-primary mb-1 fs-6"
                >
                  +48 0 123 123 123
                </a>
                <span class="text-muted fw-bold text-muted d-block fs-7">
                  Wrocław
                </span>
              </div>
            </div>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              00:10
            </a>
            <span class="text-muted fw-bold text-muted d-block fs-7">Odebrane</span>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              03:14
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Rejected</span -->
            
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              0.74 zł
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Insurance</span
            > -->
          </td>
          <td>
            <span class="badge badge-light-success fs-7 fw-bold">Sukces</span>
          </td>
          <td class="text-end">
            <a
              href="#"
              class="
                btn btn-sm btn-icon btn-bg-light btn-active-color-primary
              "
            >
              <app-keenicon name="arrow-right" class="fs-2"></app-keenicon>
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <!-- <div class="symbol symbol-50px me-5">
                <img
                  src="./assets/media/stock/600x400/img-26.jpg"
                  class=""
                  alt=""
                />
              </div> -->
              <div class="d-flex justify-content-start flex-column">
                <a
                  href="#"
                  class="text-gray-900 fw-bolder text-hover-primary mb-1 fs-6"
                >
                  +48 0 123 123 123
                </a>
                <span class="text-muted fw-bold text-muted d-block fs-7">
                  Wrocław
                </span>
              </div>
            </div>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              00:15
            </a>
            <span class="text-muted fw-bold text-muted d-block fs-7">Nie Odebrane</span>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              03:14
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Rejected</span -->
            
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              0.74 zł
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Insurance</span
            > -->
          </td>
          <td>
            <span class="badge badge-light-warning fs-7 fw-bold">Nie Odebrane</span>
          </td>
          <td class="text-end">
            <a
              href="#"
              class="
                btn btn-sm btn-icon btn-bg-light btn-active-color-primary
              "
            >
              <app-keenicon name="arrow-right" class="fs-2"></app-keenicon>
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <!-- <div class="symbol symbol-50px me-5">
                <img
                  src="./assets/media/stock/600x400/img-26.jpg"
                  class=""
                  alt=""
                />
              </div> -->
              <div class="d-flex justify-content-start flex-column">
                <a
                  href="#"
                  class="text-gray-900 fw-bolder text-hover-primary mb-1 fs-6"
                >
                  +48 0 123 123 123
                </a>
                <span class="text-muted fw-bold text-muted d-block fs-7">
                  Wrocław
                </span>
              </div>
            </div>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              00:05
            </a>
            <span class="text-muted fw-bold text-muted d-block fs-7">Odebrane</span>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              04:12
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Rejected</span -->
            
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              0.54 zł
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Insurance</span
            > -->
          </td>
          <td>
            <span class="badge badge-light-success fs-7 fw-bold">Sukces</span>
          </td>
          <td class="text-end">
            <a
              href="#"
              class="
                btn btn-sm btn-icon btn-bg-light btn-active-color-primary
              "
            >
              <app-keenicon name="arrow-right" class="fs-2"></app-keenicon>
            </a>
          </td>
        </tr>
        <tr>
          <td>
            <div class="d-flex align-items-center">
              <!-- <div class="symbol symbol-50px me-5">
                <img
                  src="./assets/media/stock/600x400/img-26.jpg"
                  class=""
                  alt=""
                />
              </div> -->
              <div class="d-flex justify-content-start flex-column">
                <a
                  href="#"
                  class="text-gray-900 fw-bolder text-hover-primary mb-1 fs-6"
                >
                  +12 0 123 123 123
                </a>
                <span class="text-muted fw-bold text-muted d-block fs-7">
                  Kraków
                </span>
              </div>
            </div>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              00:15
            </a>
            <span class="text-muted fw-bold text-muted d-block fs-7">Nie Odebrane</span>
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              00:00
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Rejected</span -->
            
          </td>
          <td>
            <a
              href="#"
              class="text-gray-900 fw-bolder text-hover-primary d-block mb-1 fs-6"
            >
              0.05 zł
            </a>
            <!-- <span class="text-muted fw-bold text-muted d-block fs-7"
              >Insurance</span
            > -->
          </td>
          <td>
            <span class="badge badge-light-danger fs-7 fw-bold">Odrzucone</span>
          </td>
          <td class="text-end">
            <a
              href="#"
              class="
                btn btn-sm btn-icon btn-bg-light btn-active-color-primary
              "
            >
              <app-keenicon name="arrow-right" class="fs-2"></app-keenicon>
            </a>
          </td>
        </tr>
      </tbody>
      <!-- end::Table body -->
    </table>
    <!-- end::Table -->
  </div>
  <!-- end::Table container -->
</div>
<!-- begin::Body -->
